export { default as ListView } from './EmployeesListView';
export { default as FormView } from './EmployeeFormView';



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/components/index.js